import { render, staticRenderFns } from "./linkedpricelistitem.vue?vue&type=template&id=443626de&scoped=true"
import script from "./linkedpricelistitem.vue?vue&type=script&lang=ts"
export * from "./linkedpricelistitem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443626de",
  null
  
)

export default component.exports